import {
  GET_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAIL,
  
  UPDATE_SETTINGS,
  UPDATE_SETTINGS_SUCCESS,
  UPDATE_SETTINGS_FAIL,
  
} from "./actionTypes"

const INIT_STATE = {
  settings: {
    settings: [],
    total: "",
    page: "",
  },

  error: {},
  loadingCreate: false,

  loading: false,

}

const Settings = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SETTINGS:
   
  
    case UPDATE_SETTINGS:
      return {
        ...state,
        loadingCreate: true,
      }

   
    case GET_SETTINGS_FAIL:

    case UPDATE_SETTINGS_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingCreate: false,
      }
 
    case GET_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: action.payload,
        error: {},
        loading: false,
      }
    
    case UPDATE_SETTINGS_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        error: {},
      }

    default:
      return state
  }
}

export default Settings
